import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { Item } from '../../../../../app/core/shared/item.model';
import { MetadataFieldWrapperComponent } from '../../../../../app/shared/metadata-field-wrapper/metadata-field-wrapper.component';

interface BfsLicense {
  label: string;
  infoPage?: string;
  image?: string;
  externalUrl?: string;
}

const CC = 'assets/images/cc-licenses/';

const LICENSES: Record<string, BfsLicense> = {
  'creativecommons.org/publicdomain/zero/1.0': { label: 'CC0 1.0', infoPage: 'licence-CC0-1-0', image: CC + 'zero.png' },
  'creativecommons.org/licenses/by/4.0': { label: 'CC BY 4.0', infoPage: 'licence-CC-BY-4-0', image: CC + 'by.png' },
  'creativecommons.org/licenses/by-sa/4.0': { label: 'CC BY-SA 4.0', infoPage: 'licence-CC-BY-SA', image: CC + 'by-sa.png' },
  'creativecommons.org/licenses/by-nc/4.0': { label: 'CC BY-NC 4.0', infoPage: 'licence-CC-BY-NC', image: CC + 'by-nc.png' },
  'creativecommons.org/licenses/by-nd/4.0': { label: 'CC BY-ND 4.0', infoPage: 'licence-CC-BY-ND', image: CC + 'by-nd.png' },
  'creativecommons.org/licenses/by-nc-sa/4.0': { label: 'CC BY-NC-SA 4.0', infoPage: 'licence-CC-BY-NC-SA', image: CC + 'by-nc-sa.png' },
  'creativecommons.org/licenses/by-nc-nd/4.0': { label: 'CC BY-NC-ND 4.0', infoPage: 'licence-CC-BY-NC-ND', image: CC + 'by-nc-nd.png' },
  'rightsstatements.org/vocab/inc/1.0': { label: 'InC 1.0', infoPage: 'licence-InC-1-0', image: 'assets/bfs/images/rightsstatements/InC.svg' },
};

// BfS: Lizenz als Badge + Kurzform, Link auf /info/licence-…
@Component({
  selector: 'ds-bfs-license-field',
  templateUrl: './bfs-license-field.component.html',
  styleUrls: ['./bfs-license-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MetadataFieldWrapperComponent, RouterLink, TranslateModule],
})
export class BfsLicenseFieldComponent implements OnChanges {
  @Input({ required: true }) item: Item;

  license: BfsLicense | null = null;

  ngOnChanges(): void {
    // dc.rights.license, Fallback dc.rights.uri (/info/licence-…) der alten Formulare
    const value = this.item?.firstMetadataValue('dc.rights.license')?.trim();
    if (value) {
      const key = value.toLowerCase().replace(/^https?:\/\//, '').replace(/\/+$/, '');
      this.license = LICENSES[key] ?? (/^https?:\/\//i.test(value) ? { label: value, externalUrl: value } : { label: value });
    } else {
      const infoPage = this.item?.firstMetadataValue('dc.rights.uri')?.split('/info/')[1];
      this.license = Object.values(LICENSES).find((l) => l.infoPage === infoPage) ?? null;
    }
  }
}
